import { generateClient, isCancelError } from 'aws-amplify/api';
import { useEffect, useState } from "react";
import { searchCrewMembers } from "../common/graphql/queries";
import FormSelectInput from "./FormSelectInput";

const client = generateClient();
let runningPromise = {};

const FormSelectCrewMember = (props) => {
    const [defaultOptions, setOptions] = useState([]);

    useEffect(() => {
        (async () => {
            const options = await loadOptions("");
            setOptions(options);
        })()
    }, [props.locationId])

    const loadOptions = async (input) => {
        try {
            if (runningPromise[props.name]) client.cancel(runningPromise[props.name], "cancelled");
            runningPromise[props.name] = client.graphql({
                query: searchCrewMembers,
                variables: {
                    filter: {
                        active: props.showAll ? undefined : { eq: true },
                        locationId: { eq: props.locationId, },
                        name: { wildcard: `*${input}*` }
                    },
                    sort: { direction: "asc", field: "name" },
                    limit: 300,
                },
            })

            const { data: { searchCrewMembers: { items } } } = await runningPromise[props.name];

            return items.map(cx => ({ value: cx.id, label: (!cx.active ? '(x) ' : '') + cx.name }))
        } catch (ex) {
            if (isCancelError(ex)) return [];
            throw ex;
        }
    }

    return (
        <FormSelectInput loadOptions={loadOptions} defaultOptions={defaultOptions} {...props} />
    )
}

export default FormSelectCrewMember;